module.exports = __webpack_public_path__ + "static/media/file-certificate.a5e41333.svg";